<template>
    <div class="form-inline">
        <b-col sm="5" class="mx-0 px-0 my-0 py-0">
            <b-input-group :prepend="$t('com_categorie', { ns: 'common' })">
                <b-form-select
                    v-model="category"
                    :options="categoryList"
                    @change="set_inputCategory"
                    :disabled="!editAllowed"
                >
                    <template #first>
                        <b-form-select-option value=""
                            >--
                            {{
                                $t('com_selecteer', {
                                    ns: 'common'
                                })
                            }}
                            --</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-input-group>
        </b-col>

        <b-col sm="7" class="mx-0 px-0 my-0 py-0">
            <b-input-group
                :prepend="$t('prod_ingredient', { ns: 'production' })"
            >
                <b-form-select
                    v-model="ingredientID"
                    :options="ingredientSubList"
                    @change="set_input"
                    :disabled="!editAllowed"
                >
                    <template #first>
                        <b-form-select-option value=""
                            >--
                            {{
                                $t('com_selecteer', {
                                    ns: 'common'
                                })
                            }}
                            --</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-input-group>
        </b-col>
    </div>
</template>
<script>
import Helper from '../../models/Helper';
import { loadList, loadItem } from '../../models/DataHelper';
export default {
    name: 'IngredientSelector',
    data: function () {
        return {
            category: '',
            ingredientID: -1,
            ingredientList: [],
            ingredientSubList: []
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        selected: {
            type: Number,
            required: true
        },
        includeWater: {
            type: Boolean,
            default: false
        },
        editAllowed: {
            type: Boolean,
            default: true
        }
    },
    components: {},
    watch: {},
    computed: {
        categoryList() {
            const lijstDistinct = Helper.distinctListKey(
                this.ingredientList,
                'category'
            );
            const lijst = lijstDistinct.map((x) => ({
                value: x.category,
                text: x.category
            }));
            if (lijst.length == 1) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.category = lijst[0].value;
                this.set_inputCategory(lijst[0].value);
            }
            lijst.push({
                value: 'water',
                text: this.$t('prod_water', { ns: 'production' })
            });
            return lijst;
        }
    },
    methods: {
        set_input(anid) {
            this.ingredientID = anid;
            const ig = this.ingredientSubList.find((x) => x.value == anid);
            this.$emit('change', true);
            this.$emit('input', this.ingredientID);
            this.$emit('baseunit', ig.baseunit);
        },
        set_inputCategory(cat) {
            const lijst = this.ingredientList.filter((x) => x.category == cat);
            this.ingredientSubList = lijst.map((x) => ({
                value: x.value,
                text: x.naam,
                baseunit: x.baseunit
            }));
            if (cat == 'water') {
                this.ingredientSubList.push({
                    value: window.constants.PRODUCT_WATER,
                    text: this.$t('prod_water', { ns: 'production' }),
                    baseunit: window.constants.LITERS
                });
            }
            if (this.ingredientSubList.length == 1) {
                this.set_input(this.ingredientSubList[0].value);
            }
            this.category = cat;
        }
    },
    async mounted() {
        if (this.category == '') {
            const product = await loadItem(
                'product/loadIngredient',
                { productID: this.selected },
                this.$t
            );
            let ingredientCatLijst =
                this.$store.getters['product/getIngredientCategorieLijst'];
            if (!ingredientCatLijst || ingredientCatLijst.length == 0) {
                await loadItem('product/loadIngredientCategories', null, this.$t)
                    .then(async (ingrcatArray) => {
                        await Promise.all(
                            ingrcatArray.map(async (ingrcat) => {
                                ingrcat.lijst = await loadItem(
                                    'product/loadIngredientInfo',
                                    { category: ingrcat.naam },
                                    this.$t
                                );
                            })
                        );
                    })
                    .then(
                        (ingredientCatLijst =
                            this.$store.getters[
                                'product/getIngredientCategorieLijst'
                            ])
                    );
            }
            const cat = this.$store.getters[
                'product/getIngredientCategorieByID'
            ](product.ingredientCatID);
            this.set_inputCategory(cat?.naam);
        }
        this.ingredientID = this.selected;
    },
    async created() {
        this.ingredientList = await loadList(
            'components/getIngredientComboLijst',
            'components/loadIngredientsForGroupComboLijst',
            null,
            true,
            this.$t
        );
    }
};
</script>

<style scoped></style>
